import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import { ClientsDashboardView } from '../../views'
import { ClientsService, LocalStorageService } from '../../../services';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { ModalUtil } from '../../pures';
import { useTranslation } from 'react-i18next';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
const timezone = localStorageService.getLocalStorageItem("timezone");
let token = localStorageService.getLocalStorageItem("token")
if (token) token = token.idToken
const clientsService = new ClientsService(url)

function ClientsDashboardAction() {
    const history = useHistory();
    const location = useLocation();

    const { t } = useTranslation();
    const modalUtil = new ModalUtil()

    const [isLoading, setIsLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState(null)
    const toggleError = (message) => setErrorMessage(message)
    const [data, setData] = useState({ dashboardData: null, clientsData: null })
    const [reviews, setReviews] = useState([]);

    const [dates, setDates] = useState({
        startDate: moment().subtract(1, 'year').toDate(),
        endDate: moment().toDate()
    })

    const handleDateChange = (event, field) => {
        setDates({ ...dates, [field]: event.target.value });
    }

    const handleViewUserDetails = (user) => {
        const searchParams = new URLSearchParams();
        searchParams.append('startDate', moment(dates.startDate).format('YYYY-MM-DD'))
        searchParams.append('endDate', moment(dates.endDate).format('YYYY-MM-DD'))

        history.push({
            pathname: `/clients-dashboard/${user.id}`,
            search: searchParams.toString(),
            state: dates
        })
    }

    const loadData = async (firstRender) => {
        setIsLoading(true)
        //toggleError(null)
        try {
            let startDate = dates.startDate
            let endDate = dates.endDate

            if (firstRender) {
                if (location.search) {
                    const searchParams = new URLSearchParams(location.search);
                    startDate = moment(searchParams.get('startDate')).toDate()
                    endDate = moment(searchParams.get('endDate')).toDate()
                    setDates({ startDate, endDate })
                }
            } else {
                const searchParams = new URLSearchParams();
                startDate = moment(dates.startDate).toDate()
                endDate = moment(dates.endDate).toDate()

                searchParams.append('startDate', moment(startDate).format('YYYY-MM-DD'));
                searchParams.append('endDate', moment(endDate).format('YYYY-MM-DD'));
                history.replace({ pathname: '/', search: searchParams.toString() })
            }

            const dashboardData = await clientsService.getClientsDashboard(token, startDate, endDate, timezone)
            const clientsData = await clientsService.getClientsList(token)
            const ratingsReviewsData = await clientsService.getRatingsReviewsData(token, startDate, endDate, timezone);
            setReviews(ratingsReviewsData);
            setData({ dashboardData, clientsData: clientsData })
            setIsLoading(false)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        loadData(true);
    }, [])
    return (
        <ClientsDashboardView
            isLoading={isLoading}
            //errorMessage={errorMessage}
            //toggleError={toggleError}
            dates={dates}
            handleDateChange={handleDateChange}
            dashboardData={data.dashboardData}
            clientsData={data.clientsData}
            handleSearch={() => loadData(false)}
            handleViewUserDetails={handleViewUserDetails}
            setData={setData}
            isDataDashboard={data}
            reviews={reviews}
        />
    )
}

export default ClientsDashboardAction